import { TestWidgets } from "../Widgets/TestingWidget"

export const Testing = () => {
    return (
        <>
            <TestWidgets />
        </>
    )
}